import API from "@utils/request";
let Language = localStorage.getItem('currentLanguage');  //获取本地语言
let prout = 'protal';
if (!Language || Language == 'zh') {
  prout = 'protal';
} else {
  prout = 'protal_' + Language;
}


// 驻站专家-列表

export async function replyArticleAns(params) {
  try {
    return await API.post("/api/" + prout + "/api/article_ans/add", params);
  } catch (error) {
    return error;
  }
}
export async function likeArticleAns(params) {
  try {
    return await API.post("/api/" + prout + "/api/article_ans/like", params);
  } catch (error) {
    return error;
  }
}



